import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CoordenadorChecked from '../../assets/images/svg/coordenadorCheck.svg';

class CoordenadorCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 24,
      height: 24,
    };
  }

  setState() {
    this.setState = {
      width: this.props.width,
      height: this.props.height,
    };
  }

  render() {
    return (
      <img
        src={CoordenadorChecked}
        width={this.state.width}
        height={this.state.height}
        className={this.props.className || ''}
        alt={'icone-check'}
        loading='lazy'
      />
    );
  }
}

CoordenadorCheck.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CoordenadorCheck;
